export default {
  type: "string",
  description: "The validity of access token in seconds",
  example: "5"
};
